import dayjs from "dayjs";

export default class AnalysisFilterViewModel {
    landUseMain: string = '01';
    landUseMainName: string = "";
    landUseSub: string = 'A';
    landUseSubName: string = "";
    timeSlice: number | null = null;
    locationType: number = 3; // 0 = outer, 1 = inner, 2 = rural, 3 = all
    tripRateParamHeaderIndex: number = 0; // 0-3 header index
    tripRateParamName: string = "";
    startYear: number = 1980;
    endYear: number = dayjs().year() - 1;
    surveyPeriodStart: number = 0;
    surveyPeriodEnd: number = 23;
    mode: number = 0; // 0 = vehicle, 1 = multimodal
    direction: number = 2; // 0 = arrivals, 1 = departures, 2 = both
    showResults: boolean = false;
}